<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <!-- '['+ model.id +']'-->
        <van-cell
          slot="header"
          :title="
            (model.type?$store.state.OrderTypeEnum.getLabel(model.type):'外派单') +
            (model.options
              ? model.options.isExcludeOrderedClerk
                ? '(排除单)'
                : ''
              : '')
          "
          icon="orders-o"
        >
          <van-tag v-if="model.status == 0" size="medium" type="danger">
            {{model.isUpload?'待客服确认':'待接单'}}
          </van-tag>
          <van-tag v-if="model.status == 1" size="medium" type="danger"
            >待支付</van-tag
          >
          <van-tag v-else-if="model.status == 2" color="#ff976a" size="medium"
            >待开始</van-tag
          >
          <van-tag v-else-if="model.status == 3" size="medium" type="primary"
            >服务中</van-tag
          >
          <van-tag v-else-if="model.status == 4" size="medium" type="success"
            >已完成</van-tag
          >
          <van-tag v-else-if="model.status == -1" size="medium">已取消</van-tag>
        </van-cell>
        <div class="content">
          <!--    用户信息      -->
          <div
            v-if="model.type != 'random' && model.user != null"
            class="row"
            style="margin-top: 0"
          >
            <div class="user_head">
              <img
                :src="model.user.headImgUrl"
                height="60px"
                style="border-radius: 50%"
                width="60px"
              />
              <div
                class="avatarFrame"
                v-if="
                  model.levelFrameUrl &&
                  !model.user.hideLevelSwitch &&
                  ((model.type == 'assigned' && $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value))
                  ||(model.type== 'reward' && $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value)))
                  "
              >
                <img
                  width="80px"
                  height="80px"
                  :src="model.levelFrameUrl"
                />
              </div>

              <template v-if="!model.user.hideLevelSwitch">
                <van-tag
                  v-if="
                    model.type == 'assigned' &&
                   $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.LEVEL.value)
                  "
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
                <van-tag
                  v-if="
                    model.type == 'reward' &&
                   $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.LEVEL.value)"
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
              </template>
            </div>
            <div class="margin-left">
              <div class="padding-bottom">
                <van-tag plain type="primary">ID：{{ model.user.id }}</van-tag>
              </div>
              <div>
                <span class="value">{{ model.user.nickname }}</span>
              </div>
            </div>
          </div>
          <!--    用户信息      -->
          <div
            v-if="
              model.type == 'random' &&
              model.user != null &&
              Object.values(model.user).filter((i) => {
                return i;
              }).length
            "
            class="row"
            style="margin-top: 0"
          >
            <div class="user_head">
              <img
                v-if="
                  model.status > 0 ||
                  $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.AVATAR.value)"
                :src="model.user.headImgUrl"
                height="60px"
                style="border-radius: 50%"
                width="60px"
              />
              <div
                v-else
                style="width: 60px; height: 60px; display: inline-block"
              ></div>
              <div
                class="avatarFrame"
                v-if="
                  model.levelFrameUrl &&
                  !model.user.hideLevelSwitch && (
                      (model.status !== 0 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value)) ||
                     (model.status === 0 && $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.AVATAR_FRAME.value)))
                "
              >
                <img
                  width="80px"
                  height="80px"
                  :src="
                     model.status != -1
                      ? model.levelFrameUrl
                      : null
                  "
                />
              </div>

              <template v-if="!model.user.hideLevelSwitch">
                <van-tag
                  v-if="
                  (model.status !== 0 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.LEVEL.value)) ||
                     (model.status === 0 && $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.LEVEL.value))"
                  class="level"
                  round
                  size="medium"
                  type="primary"
                >
                  {{ model.levelName }}
                </van-tag>
              </template>
            </div>
            <div class="margin-left">
              <div class="padding-bottom">
                <van-tag
                  v-if="
                    model.status > 0 ||
                   $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.ID.value)
                  "
                  plain
                  type="primary"
                  >ID：{{ model.user.id }}</van-tag
                >
              </div>
              <div>
                <span
                  v-if="
                    model.status > 0 ||
                   $ClerkPermission.visibleRandomOrderUserInfoWhileWaitConfirm.includes(UserInfoEnum.NICKNAME.value)"
                  class="value"
                  >{{ model.user.nickname }}</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{ model.no }}</span>
          </div>
          <div  class="row">
            <span class="label">订单内容</span>
            <span class="value">
              {{ model.gameCategoryName || '外派单' }} × {{ model.duration }} {{$store.state.TimeUnitEnum.valueOf(model.timeUnit).label}}
            </span>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{
              formatDate(model.createTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 0 && !model.isUpload"
              >已等待 {{ formatTimeDiff(model.createTime, new Date(), 0) }}</span
            >
          </div>
          <div v-if="model.status >= 2" class="row">
            <span class="label">接单时间</span>
            <span class="value">{{
              formatDate(model.confirmTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 2"
              >已等待 {{ formatTimeDiff(model.confirmTime, new Date(), 1) }}</span
            >
          </div>
          <div v-if="model.status >= 3 || (!model.payTime && model.status===1)" class="row">
            <span class="label">开始时间</span>
            <span class="value">{{
              formatDate(model.startTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="model.status == 2"
              >剩余时长
              {{ formatTimeDiff(new Date(), model.expectedEndTime, 2)}}</span
            >
          </div>
          <div v-if="model.status >= 4 || (!model.payTime && model.status===1)" class="row">
            <span class="label">结束时间</span>
            <span class="value">{{
              formatDate(model.endTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
          <div v-if="model.status == -1" class="row">
            <span class="label">取消时间</span>
            <span class="value">{{
              formatDate(model.cancelTime, "YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
<!--          <div v-if="model.isContinued != null" class="row">-->
<!--            <span class="label">是否续单</span>-->
<!--            <span class="value">-->
<!--              <van-icon-->
<!--                v-if="model.isContinued"-->
<!--                color="green"-->
<!--                name="success"-->
<!--                style="height: 20px; line-height: 20px"-->
<!--                tag="span"-->
<!--              />-->
<!--              <van-icon-->
<!--                v-if="!model.isContinued"-->
<!--                color="red"-->
<!--                name="cross"-->
<!--                style="height: 20px; line-height: 20px"-->
<!--                tag="span"-->
<!--              />-->
<!--            </span>-->
<!--            <template v-if="$store.state.shop.id != 8">-->
<!--              <van-button-->
<!--                v-if="-->
<!--                  !model.isContinued &&-->
<!--                  !model.hasContinuedApply &&-->
<!--                  (model.status ==-->
<!--                    $store.state.OrderStatusEnum.IN_SERVICE.value ||-->
<!--                    model.status == $store.state.OrderStatusEnum.FINISHED.value)-->
<!--                    && $hasFeature('order_continued_apply')-->
<!--                "-->
<!--                size="small"-->
<!--                style="height: 20px; line-height: 18px"-->
<!--                type="primary"-->
<!--                @click="showOrderContinuedApplyDialog = true"-->
<!--                >申请转为续单-->
<!--              </van-button>-->
<!--              <van-tag v-if="model.hasContinuedApply" color="#999"-->
<!--                >已申请续单</van-tag-->
<!--              >-->
<!--            </template>-->
<!--          </div>-->
<!--          <div class="row">-->
<!--            <span class="label">订单价格</span-->
<!--            ><span class="value">￥{{ formatPrice(model.totalAmount) }}</span>-->
<!--          </div>-->
          <div class="row">
            <span class="label">佣金</span>
            <span class="value">￥{{ formatPrice(model.totalWage) }}</span>
            <span v-if="model.timeUnit ==='hour'">(￥{{formatPrice(model.options.hourWage)}}/小时)</span>
            <span v-if="model.timeUnit ==='day'">(￥{{formatPrice(model.options.dayWage)}}/小时)</span>
          </div>
          <div
            v-if="model.type == 'random' && model.options != null"
            class="row"
          >
            <span class="label">买家要求</span>
            <span class="value">
              <van-tag
                v-if="model.options.clerkSex != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                  $store.state.ClerkSexEnum.getLabel(model.options.clerkSex)
                }}</van-tag>
              <van-tag
                v-if="model.gradeName != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                 model.gradeName
                }}</van-tag>
                <van-tag
                        v-if="model.rankName != null"
                        color="#f2826a"
                        plain
                        size="medium"
                        style="margin-right: 3px; margin-bottom: 5px"
                        type="danger"
                >{{
                    model.rankName
                    }}</van-tag>
              <van-tag
                v-if="model.clerkSoundName != null"
                color="#f2826a"
                plain
                size="medium"
                style="margin-right: 3px; margin-bottom: 5px"
                type="danger"
                >{{
                 model.clerkSoundName
                }}</van-tag>
            </span>
          </div>
          <div class="row">
            <span class="label">买家备注</span
            ><span class="value">{{ model.note }}</span>
          </div>
<!--          <div class="row" v-if="model.userViolationSignList && model.userViolationSignList.length > 0">-->
<!--            <span class="label">违规记录</span>-->
<!--            <span class="value"><span class="text-blue">{{ model.userViolationSignList.length }}</span>条-->
<!--            <a class="text-blue" @click="showViolation = true">查看</a>-->
<!--            </span>-->
<!--          </div>-->
          <div v-if="model.status == -1 && model.refundList" style="display: flex">
            <div style="min-width: 80px;color: #888">退款信息</div>
            <div>
              <div v-for="(item,index) in model.refundList">
                <span v-if="item.operatorRole === 'super_admin'">退款人：超级管理员</span>
                <span v-if="item.operatorRole === 'admin'">退款人：管理员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'leader'">退款人：组长-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'kf'">退款人：客服-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'clerk'">退款人：店员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'user'">退款人：用户</span>
                <span v-if="item.operatorRole === 'system'">退款人：系统</span>
                <span v-if="item.refundDesc" style="padding-left: 10px">原因：{{item.refundDesc}}</span>
              </div>
            </div>
          </div>
          <div v-if="model.refundPhotoUrls && model.refundPhotoUrls.length > 0" class="row">
            <span class="label">取消原因截图</span>
            <div class="screenshot">
              <div class="imgStyle" v-for="(item,index) in model.refundPhotoUrls" :key="index" @click="refundImgClick(index)">
                <img :src="item" class="screenshotImg">
              </div>
            </div>
          </div>
        </div>
      </van-panel>
      <div v-if="model.orderFeedBack != null" class="commentBox">
        <div class="row">
          <span class="label">反馈留言</span
          ><span class="value">{{
            model.orderFeedBack.content == ""
              ? "-"
              : model.orderFeedBack.content
          }}</span>
        </div>
        <div class="row">
          <span class="label">反馈截图</span>
          <div class="screenshot">
            <div
              v-for="(item, index) in model.orderFeedBack.photoUrls"
              :key="index"
              class="imgStyle"
              @click="imgClick(index)"
            >
              <img :src="item" class="screenshotImg" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="model != null" class="bottom-bar">
        <template v-if="model.status == 0 && !model.isUpload">
          <span v-if="model.hasConfirm">
            {{model.type==='assigned'?'等待其他店员接单':'等待客服确认'}}
          </span>
          <van-button
              v-else
          :disabled="btnConfirmDisabled"
          block
          size="normal"
          type="primary"
          @click.native="confirmOrder"
          >{{
            btnConfirmDisabled ? confirmCountDown + "s后可接单" : "确认接单"
          }}
        </van-button>
        </template>

        <van-button
          v-if="model.status === 2 && model.clerkCount===1 && (model.type === 'assigned' || model.hasKfConfirmClerk)"
          block
          size="normal"
          type="primary"
          @click.native="startService">开始服务
        </van-button>

        <van-button
          v-if="model.status === 3 && model.duration === 0"
          block
          size="normal"
          type="primary"
          @click.native="endService">结束服务
        </van-button>

        <van-button
          v-if="this.$store.state.shop.id == 163 && canChangeClerk"
          block
          size="normal"
          type="primary"
          @click="$refs.orderChangeClerk.show(model.id)">更换店员
        </van-button>

        <!--  更换店员  -->
        <OrderChangeClerk ref="orderChangeClerk" @on-success="orderChangeClerkOnSuccess"/>

<!--        &lt;!&ndash;   退款权限     &ndash;&gt;-->
<!--        <template v-if="$ClerkPermission.refundableOrderStatus.includes(model.status)">-->
<!--          &lt;!&ndash;    随机单并且待接单状态不显示取消按钮      &ndash;&gt;-->
<!--          <template v-if="model.type == 'random' ">-->
<!--            &lt;!&ndash;    待服务，服务中显示取消按钮，服务中并且服务时间超过服务时间内不可取消设置则不显示取消按钮      &ndash;&gt;-->
<!--            <div v-if="model.status == 1 || (model.status == 2 && canClerkCancelOrder)" class="margin-top">-->
<!--              <van-button block size="normal" type="warning" @click="show = true">取消订单</van-button>-->
<!--            </div>-->
<!--          </template>-->
<!--            &lt;!&ndash;    指定单      &ndash;&gt;-->
<!--          <template v-else>-->
<!--            &lt;!&ndash;    待接单、待开始、服务中显示取消按钮，服务中并且服务时间超过服务时间内不可取消设置则不显示取消按钮        &ndash;&gt;-->
<!--            <div v-if="model.status == 0 || model.status == 1 || (model.status == 2 && canClerkCancelOrder)" class="margin-top">-->
<!--              <van-button block size="normal" type="warning" @click="show = true">取消订单</van-button>-->
<!--            </div>-->
<!--          </template>-->
<!--        </template>-->

      </div>

      <certification v-if="isVerify" @close="isVerify = false"></certification>
    </div>

    <!--  查看违规内容  -->
<!--    <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList"-->
<!--                     @changeShowViolation="changeShowViolation"></ViolationSelect>-->
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Cell, CellGroup,
  Dialog,
  Field,
  Icon,
  ImagePreview,
  Panel,
  Tag,
  Toast, Uploader,
} from "vant";
import Decimal from "decimal.js";
import moment from "moment";
import VueClipboards from "vue-clipboards";
import { addOrderContinuedApply } from "@/api/clerk/order_continued_apply";
import certification from "@/views/certification";
import lrz from 'lrz'
import {confirmOrder, endService, getOrder, startService} from "@/api/clerk/dispatchOrder";
import  OrderChangeClerk from './components/order-change-clerk'

Vue.use(Panel)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Tag)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Uploader)
  .use(Field);

Vue.use(VueClipboards);

export default {
  name: "clerk-order-detail",
  components: {
    certification,
    OrderChangeClerk
  },

  data() {
    return {
      showViolation: false,
      fileList: [],
      continuedApplyFileList: [],
      ORDER: this.$store.state.order,
      UserInfoEnum: this.$store.state.UserInfoEnum,
      show: false,
      value: "",
      model: null,
      sign: null,
      btnConfirmDisabled: true,
      confirmCountDown: 3,
      cancelCountDown: null,
      canClerkCancelOrder: null,
      showOrderContinuedApplyDialog: false,
      orderContinuedApplyMessage: null,
      isVerify: false,
      clerkContinuedApplyUpload: false,
      remindUserContinued: false,
      canChangeClerk: false,
    };
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    },
  },
  methods: {
    orderChangeClerkOnSuccess(){

    },
    changeShowViolation(val){
      this.showViolation = val
    },
    // 读取前
    beforeRead() {
      return true;
    },
    // 读取后
    afterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    // 删除前
    beforeDelete() {
      if (this.fileList != null && this.fileList.length == 1) {
        Toast('至少保留1张照片');
        return false;
      }
      return true;
    },
    // 续单申请截图读取后
    continuedApplyAfterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    // 格式化时间差
    formatTimeDiff(start, end, status) {
      start = moment(start);
      end = moment(end);
      const diffSeconds = end.diff(start, "seconds");
      if (status === 3 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`;
      }
      const diffMinutes = end.diff(start, "minutes");
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`;
      }
      const diffHours = end.diff(start, "hours");
      if (diffHours < 24) {
        return `${diffHours}小时`;
      }
      const diffDays = end.diff(start, "days");
      return `${diffDays}天`;
    },
    copyCallback(success) {
      if (success) {
        Toast("复制成功");
      } else {
        Toast("复制失败，请长按文本复制");
      }
    },
    // 启用“确认订单”按钮倒计时
    startConfirmEnableCountDown() {
      let interval = window.setInterval(() => {
        this.confirmCountDown--;
        if (this.confirmCountDown <= 0) {
          window.clearInterval(interval);
          this.btnConfirmDisabled = false;
        }
      }, 1000);
    },
    hideCancelOrderButtonCountDown() {
      let interval = window.setInterval(() => {
        this.cancelCountDown--;
        if (this.cancelCountDown <= 0) {
          window.clearInterval(interval);
          this.canClerkCancelOrder = false;
        }
      }, 1000);
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model = data.order;
          this.sign = data.sign;
          this.clerkContinuedApplyUpload = data.clerkContinuedApplyUpload;
          this.remindUserContinued=data.remindUserContinued
          this.canChangeClerk = data.canChangeClerk
          this.cancelCountDown = this.$ClerkPermission.cancelOrderStartServiceWithinTime * 60;
          this.confirmCountDown =
            data.order.confirmCountDown != null
              ? data.order.confirmCountDown
              : this.confirmCountDown;
          if (this.confirmCountDown <= 0 || data.order.type == "assigned") {
            this.btnConfirmDisabled = false;
          } else {
            this.startConfirmEnableCountDown();
          }
          let validTime = moment(this.model.startTime).add(
              this.$ClerkPermission.cancelOrderStartServiceWithinTime,
            "m"
          );
          let now = moment();
          this.canClerkCancelOrder =
              this.$ClerkPermission.refundableOrderStatus.includes(2) && now < validTime;
          if (this.canClerkCancelOrder) {
            this.hideCancelOrderButtonCountDown();
          }
          if (this.model.status===3&&this.model.type==='reward' && this.$route.query.type==="reward"){
            this.getOrderRewardEffect()
          }
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    confirmOrder() {
      Toast.loading({
        mask: true,
        message: "请稍候...",
      });
      confirmOrder(this.$route.params.id,this.model.version).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: "接单成功",
          }).then(() => {
            this.loadData();
          });
        } else {
          this.loadData();

          if (data.msg == this.$store.state.label.clerkLabel + "未实名") {
            this.isVerify = true;
          } else {
            Dialog.alert({
              title: "接单失败",
              message: data.msg,
            });
          }
        }
      });
    },
    // 取消订单
    cancelOrder() {
      Dialog.confirm({
        title: "确定要取消订单？",
        message: "此操作不可撤销！",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        cancelOrder(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            this.model = null;
            Dialog.alert({
              title: "取消订单成功",
            }).then(() => [this.loadData()]);
          } else {
            Dialog.alert({
              title: "取消订单失败",
              message: data.msg,
            });
          }
        });
      });
    },
    // 开始服务
    startService() {
      Dialog.confirm({
        title: "开始服务",
        message: "请确认已与玩家成功组队！\n点击确认后开始服务计时。",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        startService(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "已开始服务",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "开始服务失败",
              message: data.msg,
            });
          }
        });
      });
    },
    // 开始服务
    endService() {
      Dialog.confirm({
        title: "结束服务",
        message: "确认结束服务吗?",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        endService(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "已结束服务",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "结束服务失败",
              message: data.msg,
            });
          }
        });
      });
    },
    onOrderContinuedApplyDialogClose(action, done) {
      if (action == "confirm") {
        if (
          this.orderContinuedApplyMessage != null &&
          this.orderContinuedApplyMessage.length > 100
        ) {
          Toast("消息不能超过100个字");
          return done(false);
        }

        // 开启截图开关
        if(this.clerkContinuedApplyUpload && this.continuedApplyFileList.length == 0){
          Toast("请上传至少一张截图");
          return done(false);
        }
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        addOrderContinuedApply(
          this.$route.params.id,
          this.orderContinuedApplyMessage,
          JSON.stringify(this.continuedApplyFileList)
        ).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "申请成功",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "申请失败",
              message: data.msg,
            });
          }
        });

        done();
      } else {
        done();
      }
    },
    refundImgClick(i){
      ImagePreview({
        images: this.model.refundPhotoUrls,
        startPosition: i,
      })
    },
    imgClick(i) {
      ImagePreview({
        images: this.model.orderFeedBack.photoUrls,
        startPosition: i,
      });
    },
  },
  mounted() {
    this.loadData();
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  },
  watch: {
    $route: function (to, from) {
      //从订单反馈过来的话就直接重新loadDate()
      if (from.meta.title === "订单反馈") {
        this.loadData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;

    .content {
      font-size: 14px;
      padding: 10px 15px;

      .row {
        .user_head {
          position: relative;
          padding: 10px;
          .level {
            position: absolute;
            left: 50%;
            height: 10px;
            font-size: 10px;
            white-space: nowrap;
            bottom: 5px;
            transform: translateX(-50%);
          }

          .avatarFrame {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }
  .wx {
    height: 20px;
    line-height: 18px;
    background-color: #f87d23;
    border: 1px solid #f87d23;
    margin-right: 15px
  }

}
</style>
